// Ilustraciones SVG de la guía de instalación — estilo bosquejo limpio con
// los tokens del handoff. Sin texto real de sistema (barras genéricas),
// sin logos de terceros. 280×420, marco de teléfono radio 36.
const INK = '#1D1D1F';
const MUTED = '#A1A1A6';
const LINE = '#D2D2D8';
const BG = '#F5F5F7';
const ELEV = '#FFFFFF';
const ACCENT = '#FF4D0D';
const SOFT = '#FFEADD';

export function PhoneSketch({ children }) {
  return (
    <svg viewBox="0 0 280 420" width="100%" style={{ display: 'block' }} role="img" aria-hidden="true">
      <rect x="4" y="4" width="272" height="412" rx="36" fill={BG} stroke={LINE} strokeWidth="2.5" />
      {children}
    </svg>
  );
}

// halo + flecha de énfasis reutilizable
const Halo = ({ cx, cy, r = 22 }) => (
  <>
    <circle cx={cx} cy={cy} r={r} fill="none" stroke={ACCENT} strokeWidth="3" />
    <circle cx={cx} cy={cy} r={r + 7} fill="none" stroke={ACCENT} strokeOpacity=".25" strokeWidth="3" />
  </>
);
const Bar = ({ x, y, w, h = 8, fill = MUTED, o = 0.5, rx = 4 }) => (
  <rect x={x} y={y} width={w} height={h} rx={rx} fill={fill} opacity={o} />
);
// mini ícono Edge Elite (marca de cancha) sobre cuadrado oscuro
const MiniAppIcon = ({ x, y, s = 44 }) => (
  <g transform={`translate(${x},${y})`}>
    <rect width={s} height={s} rx={s * 0.23} fill="#0A0A0C" />
    <path d={`M${s / 2} ${s * 0.16} v${s * 0.68}`} stroke={ACCENT} strokeOpacity=".38" strokeWidth={s * 0.055} strokeLinecap="round" />
    <circle cx={s / 2} cy={s / 2} r={s * 0.17} fill="none" stroke={ACCENT} strokeOpacity=".38" strokeWidth={s * 0.055} />
    <circle cx={s / 2} cy={s / 2} r={s * 0.08} fill={ACCENT} />
  </g>
);
// página web genérica (contenido)
const Pagina = ({ y = 64 }) => (
  <>
    <rect x="24" y={y} width="232" height="70" rx="12" fill="#0A0A0C" />
    <Bar x="38" y={y + 18} w="110" h="10" fill="#fff" o="0.9" />
    <Bar x="38" y={y + 40} w="160" h="7" fill="#fff" o="0.4" />
    <rect x="24" y={y + 84} width="232" height="46" rx="12" fill={ELEV} stroke={LINE} />
    <Bar x="38" y={y + 98} w="90" />
    <Bar x="152" y={y + 98} w="60" fill={ACCENT} o="0.85" />
    <rect x="24" y={y + 142} width="232" height="46" rx="12" fill={ELEV} stroke={LINE} />
    <Bar x="38" y={y + 156} w="120" />
  </>
);

// ── ANDROID 1: sitio + barra Chrome, ⋮ resaltado ──
export function Android1() {
  return (
    <PhoneSketch>
      <rect x="16" y="18" width="248" height="38" rx="12" fill={ELEV} stroke={LINE} />
      <rect x="28" y="28" width="170" height="18" rx="9" fill={BG} stroke={LINE} />
      <Bar x="40" y="34" w="80" h="6" />
      {/* ⋮ */}
      <g fill={INK}>
        <circle cx="243" cy="30" r="2.6" /><circle cx="243" cy="38" r="2.6" /><circle cx="243" cy="46" r="2.6" />
      </g>
      <Halo cx="243" cy="38" r="16" />
      <path d="M215 80 q16 -18 22 -30" stroke={ACCENT} strokeWidth="3" fill="none" strokeLinecap="round" markerEnd="url(#arr1)" />
      <defs><marker id="arr1" markerWidth="8" markerHeight="8" refX="4" refY="4" orient="auto"><path d="M0 0 L8 4 L0 8 z" fill={ACCENT} /></marker></defs>
      <Pagina y={96} />
    </PhoneSketch>
  );
}

// ── ANDROID 2: menú desplegado, fila "Instalar app" + diálogo Instalar ──
export function Android2() {
  return (
    <PhoneSketch>
      <rect x="16" y="18" width="248" height="30" rx="10" fill={ELEV} stroke={LINE} opacity=".6" />
      {/* menú */}
      <rect x="96" y="56" width="168" height="176" rx="14" fill={ELEV} stroke={LINE} />
      {[0, 1, 3, 4].map((i) => <Bar key={i} x="114" y={78 + i * 32} w={i % 2 ? 90 : 116} />)}
      {/* fila resaltada */}
      <rect x="104" y={78 + 2 * 32 - 10} width="152" height="28" rx="9" fill={SOFT} />
      <Bar x="114" y={78 + 2 * 32 - 1} w="14" h="10" fill={ACCENT} o="1" rx="3" />
      <Bar x="136" y={78 + 2 * 32} w="86" h="8" fill={ACCENT} o="0.9" />
      <Halo cx="180" cy={78 + 2 * 32 + 4} r="24" />
      {/* diálogo */}
      <rect x="36" y="268" width="208" height="96" rx="16" fill={ELEV} stroke={LINE} />
      <MiniAppIcon x="52" y="286" s="34" />
      <Bar x="98" y="292" w="96" h="9" fill={INK} o="0.85" />
      <Bar x="98" y="308" w="60" h="6" />
      <rect x="158" y="330" width="72" height="24" rx="9" fill={ACCENT} />
      <text x="194" y="346" textAnchor="middle" fontFamily="'Inter Tight',sans-serif" fontSize="11.5" fontWeight="800" fill="#fff">Instalar</text>
    </PhoneSketch>
  );
}

// ── ANDROID 3: home con íconos grises + Edge Elite con halo ──
export function Android3() {
  const slots = [];
  for (let r = 0; r < 4; r++) for (let c = 0; c < 4; c++) slots.push([32 + c * 58, 60 + r * 74]);
  return (
    <PhoneSketch>
      {slots.map(([x, y], i) => i === 9
        ? null
        : <g key={i}><rect x={x} y={y} width="44" height="44" rx="12" fill={LINE} opacity=".55" /><Bar x={x + 6} y={y + 52} w="32" h="5" o="0.35" /></g>)}
      <MiniAppIcon x={slots[9][0]} y={slots[9][1]} />
      <Bar x={slots[9][0] + 2} y={slots[9][1] + 52} w="40" h="5" fill={ACCENT} o="0.8" />
      <Halo cx={slots[9][0] + 22} cy={slots[9][1] + 22} r="34" />
    </PhoneSketch>
  );
}

// ── IPHONE 1: Safari con barra inferior, Compartir resaltado ──
export function Iphone1() {
  return (
    <PhoneSketch>
      <Pagina y={30} />
      {/* barra inferior Safari */}
      <rect x="16" y="352" width="248" height="48" rx="16" fill={ELEV} stroke={LINE} />
      <Bar x="36" y="372" w="24" h="7" />
      <Bar x="220" y="372" w="24" h="7" />
      {/* compartir □↑ */}
      <g stroke={ACCENT} strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <rect x="129" y="368" width="22" height="20" rx="4" />
        <path d="M140 378 v-20 M132 364 l8 -8 8 8" />
      </g>
      <Halo cx="140" cy="372" r="24" />
    </PhoneSketch>
  );
}

// ── IPHONE 2: hoja de compartir con fila "Agregar a pantalla de inicio" ──
export function Iphone2() {
  return (
    <PhoneSketch>
      <rect x="16" y="18" width="248" height="120" rx="14" fill={LINE} opacity=".35" />
      {/* sheet */}
      <rect x="12" y="150" width="256" height="262" rx="22" fill={ELEV} stroke={LINE} />
      <rect x="122" y="160" width="36" height="5" rx="2.5" fill={LINE} />
      {[0, 1, 3, 4].map((i) => (
        <g key={i}>
          <rect x="30" y={182 + i * 44} width="26" height="26" rx="8" fill={BG} stroke={LINE} />
          <Bar x="68" y={191 + i * 44} w={i % 2 ? 100 : 130} />
        </g>
      ))}
      {/* fila resaltada ⊞ */}
      <rect x="22" y={182 + 2 * 44 - 8} width="236" height="42" rx="12" fill={SOFT} />
      <g transform={`translate(30,${182 + 2 * 44})`} stroke={ACCENT} strokeWidth="2.6" fill="none" strokeLinejoin="round">
        <rect width="26" height="26" rx="8" />
        <path d="M13 8 v10 M8 13 h10" strokeLinecap="round" />
      </g>
      <Bar x="68" y={191 + 2 * 44} w="140" h="9" fill={ACCENT} o="0.9" />
      <Halo cx="43" cy={182 + 2 * 44 + 13} r="26" />
    </PhoneSketch>
  );
}

// ── IPHONE 3: diálogo Agregar a inicio, botón Agregar resaltado ──
export function Iphone3() {
  return (
    <PhoneSketch>
      <rect x="16" y="18" width="248" height="120" rx="14" fill={LINE} opacity=".35" />
      <rect x="12" y="150" width="256" height="230" rx="22" fill={ELEV} stroke={LINE} />
      {/* header del diálogo: Cancelar · título · Agregar */}
      <Bar x="30" y="172" w="52" h="8" />
      <Bar x="112" y="172" w="56" h="9" fill={INK} o="0.8" />
      <rect x="196" y="163" width="60" height="25" rx="9" fill={ACCENT} />
      <text x="226" y="180" textAnchor="middle" fontFamily="'Inter Tight',sans-serif" fontSize="11.5" fontWeight="800" fill="#fff">Agregar</text>
      <Halo cx="226" cy="175" r="30" />
      {/* preview: icono + nombre + url */}
      <MiniAppIcon x="34" y="212" s="48" />
      <Bar x="98" y="222" w="104" h="10" fill={INK} o="0.85" />
      <Bar x="98" y="240" w="70" h="7" />
      <rect x="30" y="286" width="220" height="1.6" fill={LINE} />
      <Bar x="30" y="304" w="180" h="7" o="0.35" />
      <Bar x="30" y="320" w="140" h="7" o="0.35" />
    </PhoneSketch>
  );
}
